export { default } from './ScrollIndicator'
